import { Avatar, Box, Button, Chip, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Paper, Step, StepConnector, StepLabel, Stepper, Typography, styled } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Colors from '../../../assests/style';
import moment from 'moment';
import OrderServices from '../../../services/OrderServices';
import CircleIcon from "@mui/icons-material/Circle";
import { deepPurple } from '@mui/material/colors';
import { Images } from '../../../assests';
import { ContextMenuTrigger } from 'react-contextmenu';
import { PDFExport } from '@progress/kendo-react-pdf';
import { currencyType, currencyType2 } from '../../../utils';
import { Helmet } from 'react-helmet';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const useStyles = styled({
    blurredBackground: {
        filter: 'blur(12px)', // Apply the blur effect
        transition: 'filter 0.3s ease', // Smooth transition
    },
    popupImage: {
        width: '100%',
        maxWidth: '300px',
        margin: '0 auto',
    },
    popupButton: {
        backgroundColor: '#00a8ff', // Same button color
        color: '#fff',
        marginTop: '20px',
    },
});

const steps = ['Pending', 'Processing', 'Confirmed', 'Delivered'];

const ColorConnector = styled(StepConnector)(({ theme }) => ({
    [`& .${StepConnector.line}`]: {
        borderColor: theme.palette.primary.main,
    },
}));

const ColorStepLabel = styled(StepLabel)(({ theme, active, completed }) => ({
    '& .MuiStepLabel-label': {
        color: active || completed ? ` ${Colors.secondary} !important  ` : '#a1acb1',
    },
    '& .MuiStepIcon-root': {
        color: active || completed ? theme.palette.primary.main : 'white',
    },
}));
const OrderDetail = () => {

    const classes = useStyles();
    const { state } = useLocation()
    const [rotateDirection, setRotateDirection] = useState(false)
    console.log(state);
    const [tshirtPrice, setTshirtPrice] = useState(0)
    console.log(state);
    const [open, setOpen] = useState(false);
    const [allData, setAllData] = useState(null)
    const pdfExportComponentFront = useRef(null);
    const pdfExportComponentBack = useRef(null);
    const elementFront = useRef(null)
    const elementBack = useRef(null)
    const parentRef = useRef(null);
    const divRef = useRef(null);
    const divRefBack = useRef(null);
    const [checked, setChecked] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getPricing = async () => {
        try {
            let params = {

            }
            const { data } = await OrderServices.getPricing(params)
            console.log(data);
            setTshirtPrice(data?.pricing?.standard_price)


        } catch (error) {
            console.log(error);
        } finally {

        }
    }
    const [status, setStatus] = useState(1)
    useEffect(() => {
        if (state) {
            const index = steps.findIndex(step => step.toLowerCase() === state?.status?.toLowerCase());
            console.log(index);
            setStatus(index)
        }
        getPricing()
    }, [])

    return (
        <div >
           

            <Dialog slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: "blur(8px)",
                        backgroundColor: "transparent",
                    }

                },


            }}
                PaperProps={{
                    sx: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        borderRadius: '12px',
                        '::-webkit-scrollbar': {
                            display: "none"
                        }
                    }
                }} maxWidth={'lg'} sx={{ borderRadius: '12px' }} open={open} onClose={handleClose}>

                <DialogContent className={classes.blurredBackground} sx={{
                    backgroundColor: '#0F172A', display: 'flex', alignItems: 'center', overflowY: { lg: 'hidden !important', md: 'visible !important', sm: 'visible !important', xs: 'visible !important' }, justifyContent: 'center',
                }}>
                    <Grid container justifyContent={'center'} >
                        {allData && <Grid component={'div'} className={`  tshirt-img-scale2`} ref={elementFront} item lg={6} md={12} sx={{ display: 'flex', justifyContent: 'center', height: '570px !important', position: 'relative' }}>
                            <div style={{ position: 'relative' }}>

                                <img width={'500px'} height={'570px'} id="tshirt-backgroundpicture" src={Images[allData?.color ? allData?.color : 'white']} />
                                <div style={{ position: 'absolute', top: 90, left: 145, backgroundColor: 'rgba(0,0,0,0)' }}>
                                    {!rotateDirection && <PDFExport ref={pdfExportComponentFront} paperSize="A4" scale={2.7} fileName="Frontprint">
                                        <div ref={divRef} style={{ backgroundColor: 'transparent' }} id='pdfFront'>
                                            <div className=' pdf-data' ref={parentRef} style={{ width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>

                                                {allData?.frontText && allData.frontText.length > 0 && allData.frontText.map((item, index) => {
                                                    console.log(item?.fontSize, 'dedede');
                                                    const textStyle = {
                                                        fontSize: item?.fontSize?.toString().includes('px') ? item.fontSize : `${item.fontSize}px`,
                                                        fontWeight: item.fontWeight,
                                                        fill: item.color,
                                                        fontFamily: item.fontFamily,

                                                    };

                                                    const circlePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 3} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 3} 0 1,1 -${2 * (item.width / 3)},0`;
                                                    const ellipsePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 6} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 6} 0 1,1 -${2 * (item.width / 3)},0`;
                                                    const wavePath = `M 10, ${item.width / 2} Q ${item.width / 5}, ${item.width / 5} ${2 * (item.width / 5)}, ${item.width / 2} T ${4 * (item.width / 5)}, ${item.width / 2} T ${item.width - 10}, ${item.width / 2}`;
                                                    const straightPath = `M 0,${item.width / 2} L ${item.width},${item.width / 2}`;

                                                    const shapePaths = {
                                                        circlePath,
                                                        ellipsePath,
                                                        wavePath,
                                                        straightPath,
                                                    };

                                                    const selectedPath = shapePaths[item.shape] || '';
                                                    const uniqueId = `front-circlePath${index}`;

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div
                                                                id={index}
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: `${item.width}px`,
                                                                    height: `${item.height}px`,
                                                                    top: item?.top?.toString().includes('px') ? item.top : `${item.top}px`,
                                                                    left: item?.left?.toString().includes('px') ? item.left : `${item.left}px`,
                                                                    transform: `rotate(${item.rotation}deg)`,
                                                                    zIndex: item.zIndexes,
                                                                    backgroundImage: `url('${item.url}')`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    backgroundPosition: 'center'
                                                                }}
                                                            >





                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}


                                                {allData?.frontPic.length > 0 && allData?.frontPic.map((imageData, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Grid
                                                                component={'div'}
                                                                className={`Design-${index} no-action`}
                                                                style={{
                                                                    clipPath: imageData.clipPath,
                                                                    width: `${imageData.width}px`,
                                                                    height: `${imageData.height}px`,
                                                                    position: 'absolute',
                                                                    backgroundImage: `url(${imageData?.imageUrl})`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    top: `${imageData.top}px`,
                                                                    left: `${imageData.left}px`,
                                                                    borderRadius: `${imageData.borderRadius}px`,
                                                                    transform: `${imageData.rotation}`,
                                                                    zIndex: imageData?.zIndexes
                                                                }}

                                                            />
                                                            {/* Add overlay image */}
                                                            {checked && <Grid
                                                                component={'div'}
                                                                className={`Overlay-${index}`}
                                                                style={{
                                                                    width: `${imageData.width}px`,
                                                                    height: `${imageData.height}px`,
                                                                    position: 'absolute',
                                                                    top: `${imageData.top}px`,
                                                                    left: `${imageData.left}px`,
                                                                    backgroundImage: `url(${allData?.color == 'white' ? Images?.toneWhite : allData?.color == 'black' ? Images?.toneBlack : allData?.color == 'lightgreen' ? Images?.toneGreen : allData?.color == 'darkgreen' ? Images?.toneDarkGreen : allData?.color == 'blue' ? Images?.toneBlue : allData?.color == 'yellow' ? Images?.toneOrange : allData?.color == 'purple' ? Images?.tonePurple : 'white'})`, // Path to the overlay image
                                                                    backgroundSize: 'contain',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    opacity: 0.5, // Adjust the transparency of the overlay image
                                                                    zIndex: imageData?.zIndexes + 1 // Place overlay above the image
                                                                }}
                                                            />}
                                                        </div>
                                                    );
                                                })}


                                            </div>
                                        </div>
                                    </PDFExport>}

                                </div>
                            </div></Grid>}

                        {allData && <Grid item lg={6} md={12} className={`  tshirt-img-scale2`} ref={elementBack} sx={{ display: 'flex', justifyContent: 'center', height: '570px !important' }}> <div style={{ position: 'relative' }}>
                            <img width={'500px'} height={'570px'} id="tshirt-backgroundpicture" src={Images[allData?.color ? allData?.color + "Back" : 'white' + "Back"]} />
                            <div style={{ position: 'absolute', top: 90, left: 145 }}>

                                <PDFExport ref={pdfExportComponentBack} paperSize="A4" scale={2.7} fileName="Backprint">
                                    <div ref={divRefBack} style={{ backgroundColor: 'transparent' }} id='pdfBack'>
                                        <div className='pdf-data' ref={parentRef} style={{ width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>

                                            {allData?.backText && allData?.backText.length > 0 && allData.backText.map((item, index) => {
                                                const textStyle = {

                                                    fontSize: item?.fontSize?.toString().includes('px') ? item.fontSize : `${item.fontSize}px`,
                                                    fontWeight: item.fontWeight,
                                                    fill: item.color,
                                                    fontFamily: item.fontFamily,

                                                };
                                                const circlePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 3} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 3} 0 1,1 -${2 * (item.width / 3)},0`;
                                                const ellipsePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 6} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 6} 0 1,1 -${item.width / 3},0`;
                                                const wavePath = `M 10, ${item.width / 2} Q ${item.width / 5}, ${item.width / 5} ${2 * (item.width / 5)}, ${item.width / 2} T ${4 * (item.width / 5)}, ${item.width / 2} T ${item.width - 10}, ${item.width / 2}`;
                                                const straightPath = `M 0,${item.width / 2} L ${item.width},${item.width / 2}`;

                                                const shapePaths = {
                                                    circlePath,
                                                    ellipsePath,
                                                    wavePath,
                                                    straightPath,
                                                };

                                                const selectedPath = shapePaths[item.shape] || '';
                                                const uniqueId = `back-circlePath${index}`;

                                                return (
                                                    <React.Fragment key={index}>
                                                        <ContextMenuTrigger id={`context-menu-back-${index}`}>
                                                            <div
                                                                id={`back${index}`}
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: `${item.width}px`,
                                                                    height: `${item.height}px`,
                                                                    top: item?.top?.toString().includes('px') ? item.top : `${item.top}px`,
                                                                    left: item?.left?.toString().includes('px') ? item.left : `${item.left}px`,
                                                                    transform: `rotate(${item.rotation}deg)`,
                                                                    zIndex: item.zIndexes,
                                                                    backgroundImage: `url('${item.url}')`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    backgroundPosition: 'center'
                                                                }}>

                                                            </div>
                                                        </ContextMenuTrigger>
                                                    </React.Fragment>
                                                );
                                            })}

                                            {allData?.backPic.length > 0 && allData?.backPic.map((imageUrl, index) => (
                                                <div key={index}>
                                                    <Grid
                                                        component={'div'}
                                                        className={`Design2-${index} no-action`}
                                                        style={{
                                                            clipPath: allData?.backPic[index].clipPath,
                                                            width: `${allData?.backPic[index].width}px`,
                                                            height: `${allData?.backPic[index].height}px`,
                                                            position: 'absolute',
                                                            backgroundImage: `url(${imageUrl?.imageUrl})`, // Use the base64 image
                                                            backgroundSize: 'contain',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            top: `${allData?.backPic[index].top}px`,
                                                            left: `${allData?.backPic[index].left}px`,
                                                            borderRadius: ` ${allData?.backPic[index].borderRadius}px`,
                                                            transform: `${allData?.backPic[index].rotation}`,
                                                            zIndex: imageUrl?.zIndexes
                                                        }}
                                                    />
                                                    {false && <Grid
                                                        component={'div'}
                                                        className={`Overlay2-${index}`}
                                                        style={{
                                                            width: `${imageUrl.width}px`,
                                                            height: `${imageUrl.height}px`,
                                                            position: 'absolute',
                                                            top: `${imageUrl.top}px`,
                                                            left: `${imageUrl.left}px`,
                                                            backgroundImage: `url(${allData?.color == 'white' ? Images?.toneWhite : allData?.color == 'black' ? Images?.toneBlack : allData?.color == 'lightgreen' ? Images?.toneGreen : allData?.color == 'darkgreen' ? Images?.toneDarkGreen : allData?.color == 'blue' ? Images?.toneBlue : allData?.color == 'yellow' ? Images?.toneOrange : allData?.color == 'purple' ? Images?.tonePurple : 'white'})`, // Path to the overlay image
                                                            backgroundSize: 'contain',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            opacity: 0.5, // Adjust the transparency of the overlay image
                                                            zIndex: imageUrl?.zIndexes + 1 // Place overlay above the image
                                                        }}
                                                    />}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </PDFExport>
                            </div>
                        </div></Grid>}
                    </Grid>
                </DialogContent>

            </Dialog>
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '300px', // Adjust height as needed
                    display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    position: "relative"
                }}
            >
                {/* <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        width: "100%",
                        height: "100%",
                        background: Colors.backgroundColor1
                    }}
                /> */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <p className='banner-text heading-font' style={{ fontSize: '35px', textAlign: 'center', fontFamily: "Noto Sans, sans-serif", }}> Order Detail  </p>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
            </Box>
            <Container maxWidth={'lg'} sx={{ my: 4 }} >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Box>
                        <Box sx={{ color: '#7F92B0', fontSize: '16px' }}>Order ID</Box>
                        <Box component={'div'} className='heading-font' sx={{ fontWeight: 700, fontSize: '24px' }}>{state?.order_no}</Box>
                    </Box>
                    <Box>
                        <Button
                            variant="outlined"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                padding: "5px 0px",
                                width: "200px",
                                borderRadius: "8px",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: "bold",
                                backgroundColor: state?.status == 'delivered' ? "#143D39" : '#5A4A1E', // Dark green background
                                border: state?.status == 'delivered' ? "2px solid #3FBF43" : "2px solid #D4AF37", // Green border
                                color: "#FFFFFF",
                                ":hover": {
                                    backgroundColor: state?.status == 'delivered' ? "#143D39" : '#5A4A1E', // Dark green background
                                    border: state?.status == 'delivered' ? "2px solid #3FBF43" : "2px solid #D4AF37", // Green border
                                    color: "#FFFFFF",

                                }

                            }}
                        >
                            <CircleIcon sx={{ fontSize: 12, color: "white" }} />
                            <Typography sx={{ textTransform: 'capitalize' }}>{state?.status}</Typography>
                        </Button>
                    </Box>
                </Box>
                <Grid container columnGap={7}>
                    <Grid item lg={5.7} xs={12} p={3} mt={4} sx={{ cursor: 'pointer', backgroundColor: '#1b2335', borderRadius: "15px" }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '96%' }}>

                            <Box component={'div'} className='heading-font2' sx={{ fontWeight: 400, color: 'white !important' }}>Order Details</Box>

                        </Box>
                        {console.log(state)}
                        <Divider style={{ width: '100%', borderColor: '#B0B0B04D', marginTop: '20px' }} />
                        <Grid container sx={{ mb: 2, mt: 2 }} alignItems="center" spacing={1}>
                            <Grid item xs={6} sm={4}>
                                <Box sx={{ color: 'gray', fontWeight: 600, fontSize: '14px' }}>
                                    Vendor Name :
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Box
                                    sx={{
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '12px',
                                        textAlign: 'left',
                                    }}
                                >
                                    {state?.vendor?.name}
                                </Box>
                            </Grid>
                            {[
                                { label: 'Total Designs', value: state?.designs?.length },
                                { label: 'Total Quantity', value: state?.total_qty },
                                { label: 'Total Pricing', value: state?.total_amount },
                                // { label: 'Payment Method', value: 'Card' },
                                { label: 'Promo Code', value: state?.promo_code || '-' },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={6} sm={4}>
                                        <Box sx={{ color: 'gray', fontWeight: 600, fontSize: '14px' }}>
                                            {item.label} :
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={2}>
                                        <Box
                                            sx={{
                                                color: 'white',
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </Grid>
                                </React.Fragment>
                            ))}

                        </Grid>



                    </Grid>
                    <Grid
                        item
                        lg={5.7}
                        xs={12}
                        p={3}
                        mt={4}
                        sx={{
                            cursor: 'pointer',
                            backgroundColor: '#1b2335',
                            borderRadius: '15px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '96%',
                            }}
                        >
                            <Box
                                component="div"
                                className="heading-font2"
                                sx={{
                                    fontWeight: 400,
                                    color: 'white !important',
                                    fontSize: { xs: '14px', sm: '16px', md: '18px' },
                                }}
                            >
                                User Details
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                width: '100%',
                                borderColor: '#B0B0B04D',
                                marginTop: '20px',
                            }}
                        />

                        <Grid container sx={{ mb: 2, mt: 2 }} alignItems="center" spacing={1}>
                            {[
                                { label: 'Name', value: state?.customer?.name || '-' },
                                { label: 'Phone', value: state?.customer?.phone || '-' },
                                { label: 'Address 1', value: state?.address?.address_1 || '-' },
                                { label: 'Address 2', value: state?.address?.address_2 || '-' },
                                { label: 'State', value: state?.address?.state || '-' },
                                { label: 'City', value: state?.address?.city || '-' },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={6} sm={3}>
                                        <Box
                                            sx={{
                                                color: 'gray',
                                                fontWeight: 600,
                                                fontSize: '14px',
                                            }}
                                        >
                                            {item.label} :
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box
                                            sx={{
                                                color: 'white',
                                                fontWeight: 600,
                                                fontSize: '14px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </Grid>
                    </Grid>


                    <Grid container mt={4}>
                        <Box component={'div'} className='heading-font' sx={{ fontWeight: 700, fontSize: '24px' }}>Items</Box>
                    </Grid>
                    <Grid container gap={2}>
                        <Grid sx={{ mt: 2 }} container gap={2}>
                            {state?.details?.length > 0 ? (
                                state?.details.map((item, index) => (

                                    <Grid
                                        item
                                        lg={5.7}
                                        md={5.7}
                                        sm={5.7}
                                        xs={12}
                                        display="flex"
                                        justifyContent="space-around"
                                        alignItems="center"
                                        columnGap={2}

                                        p={2}
                                        sx={{ backgroundColor: '#1b2335', borderRadius: "15px" }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: '100px',
                                                height: 'auto',
                                                '&:hover .overlay': {
                                                    opacity: 1,
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{

                                                    backgroundColor: '#0BD1D14D',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    className='no-action'
                                                    src={item.generated_art} // Use item property correctly
                                                    alt="Item"
                                                    sx={{
                                                        width: '100px',
                                                        height: '100px',
                                                        borderRadius: 1,
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                className="overlay"
                                                component={'div'}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',  // semi-transparent overlay
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    opacity: 0,
                                                    transition: 'opacity 0.3s ease',
                                                    borderRadius: 1,
                                                    color: 'white',
                                                    cursor: 'pointer'
                                                }}

                                                onClick={() => { setOpen(true); setAllData(state?.designs[item?.design_index]) }}
                                            >
                                                <Button

                                                    sx={{ color: 'white', textTransform: 'none' }}
                                                >
                                                    Preview
                                                </Button>
                                            </Box>
                                        </Box>

                                        {/* Item Details */}
                                        <Box>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Age Group : <span style={{ color: 'white' }}>{item.size_type || 'N/A'}</span>
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Size : <span style={{ color: 'white' }}>{item.size || 'N/A'}</span>
                                            </Typography>
                                            {/* {/* <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Shirt Quality : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.shirt_type || 'N/A'}</span>
                                            </Typography> */}
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Fabric : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.fabric || 'Cotton'}</span>
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Quantity : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.qty || 'N/A'}</span>
                                            </Typography>
                                        </Box>
                                    </Grid>

                                ))
                            ) : (
                                <Typography sx={{ color: 'white', textAlign: 'center' }}>
                                    Your cart is empty.
                                </Typography>
                            )}

                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={5.7} sm={12} md={12} xs={12} sx={{ borderRadius: '12px', mt: 10 }}>
                        <Box >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography className='heading-font' variant="h6" mt={0.5} gutterBottom>
                                    Order <Box className='heading-font' component={"span"}> Summary</Box>
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography className="heading-font" variant="h6" mt={0.5} gutterBottom>
                                        Shipping Type:
                                    </Typography>

                                    <Chip
                                        label={state?.shipping_type} // <-- Replace this with your dynamic shipping type
                                        color="primary" // Options: primary, secondary, success, error, etc.
                                        variant="outlined" // Or "filled"
                                        sx={{ fontWeight: "bold", fontSize: "0.85rem", textTransform: 'capitalize' }}
                                    />
                                </Box>

                            </Box>
                            <div style={{ color: '#fff' }}>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Items ({state?.total_qty})</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.sub_amount}</span>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Shipping :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.delivery_charges}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Discount :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.promo_discount}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Sub Total :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {parseFloat(parseFloat(state?.sub_amount) + parseFloat(state?.delivery_charges)) - parseFloat(state?.promo_discount)}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>GST 18% :</span>
                                    <span >
                                        {(() => {
                                            const subtotal =
                                                parseFloat(state?.sub_amount || 0) +
                                                parseFloat(state?.delivery_charges || 0) -
                                                parseFloat(state?.promo_discount || 0);

                                            const vat = subtotal * 0.18;
                                            const total = vat;

                                            return `${currencyType2[state?.vendor?.country]?.code} ${total.toFixed(2)} `;
                                        })()}
                                    </span>

                                </div>
                                <hr style={{ borderColor: '#fff', margin: '20px 0' }} />
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Poppins, sans-serif', color: Colors.secondary }}>
                                    <Typography className='heading-font' variant="h6" gutterBottom>
                                        Order <Box className='heading-font' component={"span"}> Total :</Box>
                                    </Typography>
                                    <span className="heading-font">
                                        {(() => {
                                            const subtotal =
                                                parseFloat(state?.sub_amount || 0) +
                                                parseFloat(state?.delivery_charges || 0) -
                                                parseFloat(state?.promo_discount || 0);

                                            const vat = subtotal * 0.18;
                                            const total = subtotal + vat;

                                            return `${currencyType2[state?.vendor?.country]?.code} ${total.toFixed(2)} `;
                                        })()}
                                    </span>

                                </div>
                                <hr style={{ borderColor: '#fff', margin: '20px 0' }} />

                            </div>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </div >
    )
}

export default OrderDetail
